import React from 'react';
import { ArticleHeader } from './components/ArticleHeader';
import { ArticleSection } from './components/ArticleSection';
import { ProductSection } from './components/ProductSection';
import { ClosingSection } from './components/ClosingSection';
import { SiteFooter } from './components/SiteFooter';
import { article, dangers, solutionSections } from './data/article';
export function App() {
  React.useEffect(() => {
    document.title = article.headline;

    // Initialize Meta Pixel
    const f = window as any;
    if (f.fbq) return;
    const n = (f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    }) as any;
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    const t = document.createElement('script');
    t.async = !0;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const s = document.getElementsByTagName('script')[0];
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s);
    } else {
      document.head.appendChild(t);
    }
    f.fbq('init', '932263746333538');
    f.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-full w-full bg-paper font-sans text-ink" data-id="element-0" data-mp="3mjg7xft4rzjk">
      <main data-id="element-1" data-mp="3rdkg22e4udm8">
        <ArticleHeader data-id="element-2" data-mp="3rd1bdndhtlq5" />

        {dangers.map(section => <ArticleSection key={section.id} section={section} emphasis="danger" data-id="element-3" data-mp="6817u0q2c9h" />)}

        {solutionSections.map(section => <ArticleSection key={section.id} section={section} data-id="element-4" data-mp="2zmwggus3xgao" />)}

        <ProductSection data-id="element-5" data-mp="33nges1of2pye" />
        <ClosingSection data-id="element-6" data-mp="33mylndx1wrup" />
      </main>

      <SiteFooter data-id="element-7" data-mp="38m1f013o59mu" />
    </div>;
}